import { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ColorEditor = ({ token, colors, onChange }) => {
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(-1);
  const [error, setError] = useState("");

  const set = (i, patch) => onChange(colors.map((c, j) => (j === i ? { ...c, ...patch } : c)));
  const addColor = () => { if (name.trim()) { onChange([...colors, { name: name.trim(), image: "" }]); setName(""); } };
  const upload = async (i, file) => {
    if (!file) return;
    setBusy(i); setError("");
    const form = new FormData();
    form.append("file", file);
    try {
      const r = await axios.post(`${API}/admin/upload`, form, { headers: { "X-Admin-Token": token } });
      set(i, { image: r.data.url });
    } catch (err) { setError(err?.response?.data?.detail || "Upload failed"); } finally { setBusy(-1); }
  };

  return (
    <div className="field full-row" data-testid="product-form-colors">
      <span>Colours (optional · each can have its own photo)</span>
      <div className="color-rows">
        {colors.map((c, i) => (
          <div className="color-row" key={i} data-testid={`color-row-${i}`}>
            <label className="color-photo" title="Upload photo for this colour">
              {c.image ? <img src={c.image} alt={c.name} /> : <small>{busy === i ? "…" : "+ Photo"}</small>}
              <input type="file" accept="image/jpeg,image/png,image/webp" hidden onChange={e => upload(i, e.target.files?.[0])} data-testid={`color-photo-input-${i}`} />
            </label>
            <input value={c.name} onChange={e => set(i, { name: e.target.value })} data-testid={`color-name-${i}`} />
            <button type="button" className="admin-danger" onClick={() => onChange(colors.filter((_, j) => j !== i))} data-testid={`color-remove-${i}`}>Remove</button>
          </div>
        ))}
        <div className="color-row">
          <input value={name} onChange={e => setName(e.target.value)} onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); addColor(); } }} placeholder="e.g. Mint" data-testid="color-new-name" />
          <button type="button" className="admin-refresh" onClick={addColor} data-testid="color-add">Add colour</button>
        </div>
      </div>
      {error && <small className="eta-error" data-testid="color-error">{error}</small>}
    </div>
  );
};
